import { getUserSessionData } from '../vue/composables/useCraft';
import { withPlugins, domEvents } from '@spon/plugins';

function setCookie(name, value, days) {
	var expires = '';
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
}

/*
 *		Behaviour
 */
async function AlertCTA({ node, plugins: { addEvents } }) {
	/*
	 *		Variables
	 */

	const user = await getUserSessionData();
	const mudCookie = getCookie('mud-craft-core-cookies');
	const seenAlert = getCookie(`alert-notice-${node.dataset.alert}`);

	/*
	 *		Functions
	 */
	function removeWidget() {
		node.remove();
		return;
	}

	function closeWidget() {
		// Set cookie as seen
		// (whether clicked close, or a link)
		setCookie(`alert-notice-${node.dataset.alert}`, 'seen', 30);

		node.classList.remove('show-shapes');
		setTimeout(() => {
			node.classList.remove('is-open');
		}, 350);
	}

	function showWidget() {
		node.classList.add('is-open');
		setTimeout(() => {
			node.classList.add('show-shapes');
		}, 700);
	}

	function showWidgetAfterCookies() {
		// document.removeEventListener('mudCookiesClosed', showWidgetAfterCookies);
		document.removeEventListener('mudCookiesSaved', showWidgetAfterCookies);
		return setTimeout(showWidget, 1000);
	}

	/*
	 *		Logic
	 */

	// Initial checks: If user seen specific alert (by CMS ID)
	// ..or if we have any user `level`, never show Members Only Alerts
	if (seenAlert || user.uid) removeWidget();

	// If we have a cookie value (whatever it is); add content & show..
	if (typeof mudCookie === 'string') {
		setTimeout(showWidget, 1000);
	} else {
		// .. otherwise dont add popout; add listener for when cookies have been accepted...
		document.addEventListener('mudCookiesClosed', showWidgetAfterCookies);
		document.addEventListener('mudCookiesSaved', showWidgetAfterCookies);
	}

	/*
	 *		Events
	 */
	addEvents({
		'click a': closeWidget,
		'click [data-close]': closeWidget,
	});
}

export default withPlugins(domEvents)(AlertCTA);
